const updateOneTimeLoginLink = (state, { payload: { oneTimeLoginLink } }) => {
	state.oneTimeLoginLink = oneTimeLoginLink;
};

export default updateOneTimeLoginLink;
